import { useMemo } from 'react'

import { useDetailViewContext } from 'features/views/DetailView/hooks/useDetailViewContext'

export function useDetailViewCompactHeaderState() {
    const { recordManager, topOffset, rightOffset } = useDetailViewContext()!

    const isLoading = recordManager.isLoadingSlow

    const isError = recordManager.isError

    return useMemo(
        () => ({ isLoading, topOffset, rightOffset, isError }),
        [isLoading, topOffset, rightOffset, isError]
    )
}
